<template>
  <button
    ref="buttonFocus"
    class="btn btn-primary btnNormal"
    type="button"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <img v-show="imgURL != null" :src="imgURL" />
    {{ buttonName }}
  </button>
</template>

<script>
export default {
  name: 'ButtonNormal',
  props: {
    isFocus: {
      type: Boolean,
      default: false
    },
    buttonName: String,
    disabled: Boolean,
    imgURL: String
  },
  watch: {
    // ルーター
    $route(to, from) {
      if (to.params.focus === true) {
        this.focus()
      }
    }
  },
  mounted() {
    this.focus()
  },
  methods: {
    focus() {
      if (this.isFocus === true) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.buttonFocus && !this.$refs.buttonFocus.value) {
              this.$refs.buttonFocus.focus()
            }
          }, 500)
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btnNormal {
  background-color: rgb(239, 250, 255) !important;
  border-color: rgb(154, 154, 154);
  color: rgb(0, 0, 0);
  min-width: 80px;
  height: 25px;
  font-size: 14px;
  padding: 0 1em;
}
.btnNormal:hover {
  filter: opacity(70%);
  background-color: rgb(239, 250, 255);
  border-color: rgb(154, 154, 154);
  color: rgb(0, 0, 0);
}
button:disabled {
  color: rgb(154, 154, 154);
  background-color: rgb(225, 225, 225);
  border: none;
  border-radius: 4px;
}
.btnNormal:focus {
  outline: 0 !important;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
</style>
